<template>
  <div class="card">
    <div class="card-header">
      <div class="card-title d-flex align-items-center">
        <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
          <inline-svg src="media/icons/duotune/ecommerce/ecm002.svg" />
        </span>
        <h3 class="fw-bold m-0 text-gray-800">Pedidos</h3>
      </div>
      <div
        v-if="this.modal === true"
        class="btn btn-icon btn-sm btn-active-light-primary mt-6"
        data-bs-dismiss="modal"
        @click="this.$emit('fecharPedido', false)"
      >
        <span class="svg-icon svg-icon-2x">
          <img src="media/icons/duotune/arrows/arr061.svg" />
        </span>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div
            v-if="!this.showFilter"
            class="d-flex align-items-center position-relative my-1"
          >
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarPedidos"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-225px ps-15"
              placeholder="Pesquisar Pedidos"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            v-if="checkedPedidos.length === 0"
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <button
              v-if="this.modal === false"
              @click="this.$refs.table.exportarExcel()"
              type="button"
              class="btn btn-sm btn-light-primary me-3"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
              </span>
              Exportar
            </button>
            <router-link
              v-if="this.adicionar && this.modal === false"
              to="/movimentacao/pedidos/editar"
              class="btn btn-sm btn-primary"
              ><span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar</router-link
            >
            <button
              v-if="this.adicionar && this.modal === true"
              @click="this.$emit('adicionarPedido')"
              class="btn btn-sm btn-primary"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/general/gen041.svg" /></span
              >Adicionar
            </button>
          </div>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checkedPedidos.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.excluir && this.modal === false"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSelecionados()"
            >
              Excluír Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="this.modal === false ? tableHeader : tableHeaderModal"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum pedido encontrado"
          @checked-rows="checkedPedidos = $event"
          :colors="true"
          @showFilter="this.showFilter = $event"
        >
          <template v-slot:cell-checkbox="{ row: pedido }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="pedido.id"
                v-model="checkedPedidos"
              />
            </div>
          </template>
          <template v-slot:cell-PedidoClienteClienteFoto="{ row: pedido }">
            <div
              v-if="
                pedido.PedidoCliente &&
                pedido.PedidoCliente.Cliente &&
                pedido.PedidoCliente.Cliente.foto
                  ? pedido.PedidoCliente.Cliente.foto
                  : ''
              "
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() + pedido.PedidoCliente.Cliente.foto
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div :class="['symbol-label fs-2 fw-bold ' + pedido.color]">
                {{
                  pedido.PedidoCliente && pedido.PedidoCliente.nome
                    ? pedido.PedidoCliente.nome.substring(0, 1).toUpperCase()
                    : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-id="{ row: pedido }">
            <div class="text-dark fw-bolder">
              {{ pedido.id }}
            </div>
          </template>
          <template v-slot:cell-PedidoClienteNome="{ row: pedido }">
            <div class="min-w-150px align-middle">
              <div>
                <span class="text-dark text-hover-primary mb-1">
                  {{
                    pedido.PedidoCliente && pedido.PedidoCliente.nome
                      ? pedido.PedidoCliente.nome
                      : ""
                  }}
                </span>
                <span class="text-muted fw-bold d-block">
                  {{
                    pedido.PedidoCliente && pedido.PedidoCliente.cpf_cnpj
                      ? pedido.PedidoCliente.cpf_cnpj.length === 11
                        ? this.$utils.setMask(
                            pedido.PedidoCliente.cpf_cnpj,
                            "###.###.###-##",
                            true
                          )
                        : this.$utils.setMask(
                            pedido.PedidoCliente.cpf_cnpj,
                            "##.###.###/####-##",
                            true
                          )
                      : ""
                  }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:cell-situacao="{ row: pedido }">
            <span
              :class="[
                pedido.situacao ? this.getSituacaoColor(pedido.situacao) : '',
              ]"
              >{{ pedido.situacao }}</span
            >
          </template>
          <template v-slot:cell-total="{ row: pedido }">
            <div class="text-dark fw-bolder align-middle min-w-100px">
              R$ {{ this.$utils.formatarNumero(pedido.total) }}
            </div>
          </template>
          <template v-slot:cell-data_emissao="{ row: pedido }">
            <div class="min-w-100px">
              {{ this.$utils.formatarData(pedido.data_emissao) }}
            </div>
          </template>
          <template v-slot:cell-tipo="{ row: pedido }">
            <span
              :class="[pedido.tipo ? this.getTipoColor(pedido.tipo) : '']"
              >{{ pedido.tipo }}</span
            >
          </template>
          <template v-slot:cell-acoes="{ row: pedido }">
            <div :class="[this.modal === true && 'min-w-200px']">
              <button
                v-if="this.modal === true"
                class="btn btn-sm btn-light-primary me-2"
                @click="selecionarRegistro(pedido)"
              >
                Selecionar
              </button>
              <button
                class="btn btn-sm btn-light btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                v-if="this.editar || this.excluir"
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
                data-kt-menu="true"
              >
                <div
                  v-if="this.editar && this.modal === false"
                  class="menu-item px-3"
                >
                  <a @click="editarRegistro(pedido.id)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span></a
                  >
                </div>
                <div
                  v-if="this.editar && this.modal === true"
                  class="menu-item px-3"
                >
                  <a
                    @click="this.$emit('editarPedido', pedido.id)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span></a
                  >
                </div>
                <div v-if="this.excluir" class="menu-item px-3">
                  <a @click="removerRegistro(pedido.id)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr015.svg"
                        class="me-2"
                      />Excluir
                    </span></a
                  >
                </div>
                <div class="menu-item px-3">
                  <a @click="imprimirPedido(pedido.id)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/files/fil004.svg"
                        class="me-2"
                      />Imprimir
                    </span></a
                  >
                </div>
                <div
                  class="menu-item px-3"
                  v-if="pedido.situacao === 'Pendente'"
                >
                  <a @click="faturarPedido(pedido.id)" class="menu-link px-3">
                    <span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/ecommerce/ecm008.svg"
                        class="me-2"
                      />Faturar Pedido
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <ViewFilePDF
    v-if="exibirImpressaoPDF"
    :documento="documentoImpressao"
    @exibirModalImpressao="exibirModalImpressao"
  ></ViewFilePDF>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import ViewFilePDF from "@/components/modals/general/ViewFilePDF";

const toast = useToast();

export default {
  emits: [
    "selecionarPedido",
    "fecharPedido",
    "adicionarPedido",
    "editarPedido",
  ],
  components: {
    Datatable,
    ViewFilePDF,
  },
  props: {
    modal: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(situacao, '" +
          pesquisa +
          "') or contains(tipo, '" +
          pesquisa +
          "') or contains(PedidoCliente/nome, '" +
          pesquisa +
          "') or contains(PedidoCliente/cpf_cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja remover os registros selecionados?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            for (var i = 0; i < this.checkedPedidos.length; i++) {
              await this.excluirPedido(this.checkedPedidos[i]);
            }
            if (this.excluiuCadastro === true) {
              toast.success("Pedidos excluídos com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async removerRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            await this.excluirPedido(id);
            if (this.excluiuCadastro === true) {
              toast.success("Pedido excluído com sucesso!", { timeout: 3000 });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async excluirPedido(id) {
      try {
        await this.$store.dispatch("pedido/deletePedido", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    async exibirModalImpressao(exibir) {
      if (exibir === true) {
        this.exibirImpressaoPDF = true;
        getOrCreateInstanceModal(
          "kt_modal_view_file_pdf",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_view_file_pdf");
          },
          /*close*/ () => {
            this.exibirModalImpressao(false);
          }
        );
      } else {
        hideModalId("kt_modal_view_file_pdf", () => {
          this.documentoImpressao = [];
          this.exibirImpressaoPDF = false;
        });
      }
    },
    async imprimirPedido(id) {
      try {
        this.documentoImpressao = [];
        this.$refs.table.setLoading(true);
        var response = await this.$store.dispatch("pedido/imprimirPedido", id);
        //console.log(response);
        if (response.status === 200) {
          // const imp = document.getElementById("impressao");
          // imp.innerHTML = response.data;

          //console.log(response.data);

          // await this.$utils
          //   .blobToBase64(new Blob([response.data]))
          //   .then((res) => {
          //     this.documentoImpressao = res;
          //   });

          this.documentoImpressao = response.data;

          await this.exibirModalImpressao(true);

          // var fileURL = window.URL.createObjectURL(new Blob([response.data]), {
          //   type: "application/pdf",
          // });
          // var fileLink = document.createElement("a");
          // fileLink.href = fileURL;
          // fileLink.setAttribute("download", "Pedido-" + id + ".pdf");
          // document.body.appendChild(fileLink);
          // fileLink.click();
        }
      } catch (error) {
        console.log(error);
        await this.$swal.showInvalidAlert(
          "Não foi possível imprimir o pedido!"
        );
      }
      this.$refs.table.setLoading(false);
    },
    editarRegistro(id) {
      this.$router.push("/movimentacao/pedidos/editar/" + id);
    },
    selecionarRegistro(pedido) {
      this.$emit("selecionarPedido", pedido);
    },
    getSituacaoColor(situacao) {
      if (situacao.toUpperCase() === "FATURADO") {
        return "badge badge-light-success text-success";
      } else if (situacao.toUpperCase() === "ATRASADO") {
        return "badge badge-light-danger text-danger";
      } else if (situacao.toUpperCase() === "ENTREGUE") {
        return "badge badge-light-info text-info";
      } else if (situacao.toUpperCase() === "PENDENTE") {
        return "badge badge-light-primary text-primary";
      } else {
        return "badge badge-light-dark text-dark";
      }
    },
    getTipoColor(tipo) {
      if (tipo.toUpperCase() === "DELIVERY") {
        return "badge badge-light-info text-info";
      } else if (tipo.toUpperCase() === "AGENDAMENTO") {
        return "badge badge-light-warning text-warning";
      } else if (tipo.toUpperCase() === "RETIRADA") {
        return "badge badge-light-primary text-primary";
      } else {
        return "badge badge-light-dark text-dark";
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Pedido.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Pedido.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Pedido.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
    async faturarPedido(id) {
      await this.$swal.showQuestionAlert(
        "Deseja faturar o pedido selecionado?",
        (alert) => {
          if (alert.isConfirmed) {
            this.$router.push(
              "/movimentacao/faturamento/editar?ImportarPedido=" + id
            );
          }
        }
      );
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarPedidos");
    }, 800);
  },
  data() {
    return {
      showFilter: false,
      documentoImpressao: [],
      exibirImpressaoPDF: false,
      adicionar: false,
      editar: false,
      excluir: false,
      checkedPedidos: [],
      errosValidacaoGeral: [],
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          key: "PedidoClienteClienteFoto",
          sortingField: "PedidoCliente/Cliente/foto",
          sortable: false,
        },
        {
          name: "Número Pedido",
          key: "id",
          sortable: true,
        },
        {
          name: "Cliente",
          key: "PedidoClienteNome",
          sortingField: "PedidoCliente/nome",
          sortable: true,
        },
        {
          name: "Situação",
          key: "situacao",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "data_emissao",
          sortable: true,
        },
        {
          name: "Tipo",
          key: "tipo",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableHeaderModal: [
        {
          name: "Número Pedido",
          key: "id",
          sortable: true,
        },
        {
          key: "PedidoClienteClienteFoto",
          sortingField: "PedidoCliente/Cliente/foto",
          sortable: false,
        },
        {
          name: "Cliente",
          key: "PedidoClienteNome",
          sortingField: "PedidoCliente/nome",
          sortable: true,
        },
        {
          name: "Situação",
          key: "situacao",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Emissão",
          key: "data_emissao",
          sortable: true,
        },
        {
          name: "Tipo",
          key: "tipo",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "pedido/getPedidoOData",
        selectOData:
          "?$select=id,situacao,total,data_emissao,tipo&$expand=PedidoCliente($select=nome,cpf_cnpj;expand=Cliente($select=foto))",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
